import { createAction } from "redux-actions";

import {
  GET_WATCHLIST_UPDATE_LOGS,
  GET_WATCHLIST_UPDATE_LOGS_COUNT,
  SET_WATCHLIST_UPDATE_LOGS_ITEMS_PER_PAGE,
  SET_WATCHLIST_UPDATE_LOGS_PAGE,
} from "../types";
import createAsyncActions from "../../../utilities/createAsyncActions";

export const {
  getWatchListUpdateLogs,
  getWatchListUpdateLogsPending,
  getWatchListUpdateLogsFulfilled,
  getWatchListUpdateLogsRejected,
} = createAsyncActions(GET_WATCHLIST_UPDATE_LOGS, "getWatchListUpdateLogs");

export const {
  getWatchListUpdateLogsCount,
  getWatchListUpdateLogsCountPending,
  getWatchListUpdateLogsCountFulfilled,
  getWatchListUpdateLogsCountRejected,
} = createAsyncActions(
  GET_WATCHLIST_UPDATE_LOGS_COUNT,
  "getWatchListUpdateLogsCount"
);

export const setCurrentPage = createAction(SET_WATCHLIST_UPDATE_LOGS_PAGE);
export const setItemsPerPage = createAction(
  SET_WATCHLIST_UPDATE_LOGS_ITEMS_PER_PAGE
);



// WEBPACK FOOTER //
// ./src/features/reports/actions/getWatchListUpdateLogsActions.js